import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Plan, Product } from "@brain/models";
import { Sku } from "@shared/cards/ui/sku-card";
import { EMPTY, Observable, zip } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { Transaction, TransactionData } from "../data/transaction";
import { BASE_URI } from "./token";
import { TransactionService } from "./transaction.service";

@Injectable()
export class DeloitteAiTransactionResolver implements Resolve<TransactionData> {

    constructor(
        private transactionService: TransactionService,
        private http: HttpClient,
        @Inject(BASE_URI) private apiUrl: string
    ) { }

    resolve(activatedRoute: ActivatedRouteSnapshot): Observable<TransactionData> {

        const transactionid = activatedRoute.params.transaction_id;

        if (transactionid) {
            return this.transactionService.getTransaction(transactionid)
                .pipe(
                    switchMap((response: Transaction) => {
                        /** get additional data for the cart */
                        const { product_id, sku_id, plan_id } = response;

                        const product$ = this.http.get<Product>(this.apiUrl + `/catalog/global/products/${product_id}`);
                        const sku$ = this.http.get<Sku>(this.apiUrl + `/catalog/global/products/${product_id}/skus/${sku_id}`);
                        const plan$ = this.http.get<Plan>(this.apiUrl + `/catalog/global/products/${product_id}/skus/${sku_id}/plans/${plan_id}`);

                        return zip(product$, sku$, plan$).pipe(map<[Product, Sku, Plan], TransactionData>(
                            ([product, sku, plan]) => ({ product, plan, sku, transaction: response })
                        ));
                    })
                );
        }

        return EMPTY;
    }
}
